module.exports = __webpack_public_path__ + "img/halloween-rock-1.f63eeea1.svg";